window.slate = window.slate || {};
window.theme = window.theme || {};
window.sections = window.sections || {};
var bodyClasses = document.body.classList;

// Init values for drawers control
theme.drawerOpen = false;

/*================ Slate ================*/
/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
	  if (typeof cents == 'string') { cents = cents.replace('.',''); }
	  var value = '';
	  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	  var formatString = (format || moneyFormat);
	
	  function defaultOption(opt, def) {
	     return (typeof opt == 'undefined' ? def : opt);
	  }
	
	  function formatWithDelimiters(number, precision, thousands, decimal) {
	    precision = defaultOption(precision, 2);
	    thousands = defaultOption(thousands, ',');
	    decimal   = defaultOption(decimal, '.');
	
	    if (isNaN(number) || number == null) { return 0; }
	
	    number = (number/100.0).toFixed(precision);
	
	    var parts   = number.split('.'),
	        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
	        cents   = parts[1] ? (decimal + parts[1]) : '';
	
	    return dollars + cents;
	  }
	
	  switch(formatString.match(placeholderRegex)[1]) {
	    case 'amount':
	      value = formatWithDelimiters(cents, 2);
	      break;
	    case 'amount_no_decimals':
	      value = formatWithDelimiters(cents, 0);
	      break;
	    case 'amount_with_comma_separator':
	      value = formatWithDelimiters(cents, 2, '.', ',');
	      break;
	    case 'amount_no_decimals_with_comma_separator':
	      value = formatWithDelimiters(cents, 0, '.', ',');
	      break;
	  }
	
	  return formatString.replace(placeholderRegex, value);
	};

  return { formatMoney: formatMoney };
  
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * Filter  Script
 * ------------------------------------------------------------------------------
 * Will triggers <select> changes on collection and cart pages.
 *
 * @namespace filters
 */
 
slate.Filters = (function() {
	var constants = {
		SORT_BY: 'sort_by'
	};
	var selectors = {
		filterSelection			: '[filters-filter]',
		sortSelection			: '[filters-sort]',
		defaultSort				: '[filters-default-sort]'
	};
	
	/**
	 * Filters constructor. 
	 * @param {string} container - selector for the section container DOM element
	 */
	function Filters(container) {
		this.$container = this.$container = $(container);

	    this.$filterSelect = $(selectors.filterSelection, this.$container);
	    this.$sortSelect = $(selectors.sortSelection, this.$container);
	    this.$selects = $(selectors.filterSelection, this.$container).add($(selectors.sortSelection, this.$container));
	
	    this.defaultSort = this._getDefaultSortValue();
	    this.$selects.removeClass('hidden');
	
	    this.$filterSelect.on('change', this._onFilterChange.bind(this));
	    this.$sortSelect.on('change', this._onSortChange.bind(this));
	}
	
	
	Filters.prototype = $.extend({}, Filters.prototype, {
		_onSortChange: function(evt) {
			var sort = this._sortValue();
			if (sort.length) {
				window.location.search = sort;
			} else {
				// clean up our url if the sort value is blank for default
				window.location.href = window.location.href.replace(window.location.search, '');
			}
		},
		
		_onFilterChange: function(evt) {
			window.location.href = this.$filterSelect.val() + window.location.search;
		},
		
		_getSortValue: function() {
			return this.$sortSelect.val() || this.defaultSort;
		},
		
		_getDefaultSortValue: function() {
			return $(selectors.defaultSort, this.$container).val();
		},
		
		_sortValue: function() {
			var sort = this._getSortValue();
			var query = '';
		
			if (sort !== this.defaultSort)
				query = constants.SORT_BY + '=' + sort;
				
			return query;
		}
	});
	
	return Filters;
})();

/*================ Sections ================*/
/**
 * Slider Section Script
 * ------------------------------------------------------------------------------
 * @namespace Slider
 */
theme.Slider = (function() {
	var selectors = {
		slickHero: '#slick-hero'
	};

	/**
	 * Product section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	*/
	function Slider(container) {
		this.$container 		= $(container);
		this.namespace 			= '.Slider';
		var sectionId 			= this.$container.attr('data-section-id');
		
		this.$slickHero			= $(selectors.slickHero);
		this.sliderAuto		 	= this.$container.data('slider-autoplay');
		this.sliderAutoSpeed 	= ~~this.$container.data('slider-autoplay-speed');
		
		// INIT
		this.init();
		
		// EVENTS
		this.events();
	}

	Slider.prototype = $.extend({}, Slider.prototype, {

		/**
		 * Init Slider
		**/
		init: function() {
			var _slick = null, initTriggered = false;
			
			// Set Observer to trigger when the Class 'Lazyloaded' is added
			var mutationObserver = new MutationObserver(function(mutationList, observer) {
				initTriggered = true;
				$.each(mutationList, function(key, mutation) {
					if ( mutation.attributeName === 'class' && $(mutation.target).hasClass('lazyloaded') ) {
						_slick.$slides.eq(_slick.currentSlide).find('.heading-wrapper').removeClass('off');
						if (_slick.$dots) 
							_slick.$dots.addClass('active');
					}
				});
			});
			
			this.$slickHero.on('init', function(event, slick) {
				_slick = slick; // Make it accessible to the MutationObserver
				// Observe class change on image (lazy loading);
				slick.$slides.eq(slick.currentSlide).find('img').each(function() {
					mutationObserver.observe( $(this)[0], { attributes: true } ); // Attached the 2 images
				});
			});
		
			this.$slickHero.slick({
				infinite: true,
				autoplay: this.sliderAuto,
				autoplaySpeed: this.sliderAutoSpeed,
				arrows: false,
				dots: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				fade: true,
				waitForAnimate: true
			});
			
			// Because of cache sometimes observer on the 'init' event of Lazyload won't be trigger
			// as it is declared as the image lazyload
			// Fail safe, the animation is triggered if init failed afer 1200 ms
			setTimeout(function() {
				if (!initTriggered) {
					this.$slickHero.find('.slick-active .heading-wrapper').removeClass('off');
					if (_slick.$dots && _slick.$dots.length)
						_slick.$dots.addClass('active');
				}
			}.bind(this), 1200);

			
		},
		
		/**
		 * Events
		**/
		events: function() {
			this.$slickHero.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				var $next = slick.$slides.eq(currentSlide);
				$next.find('.heading-wrapper').addClass('off');
				$next.find('img').removeClass('lazyloaded');
				slick.$dots.removeClass('active');
			});
			
			this.$slickHero.on('afterChange', function(event, slick, currentSlide) {
				var $current = slick.$slides.eq(currentSlide);
				$current.find('img').addClass('lazyloaded');
				$current.find('.heading-wrapper').removeClass('off');
				slick.$dots.addClass('active');
			});
		},
		
		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onLoad: function() {
			this.init();
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function() {
			this.$container.off(this.namespace);
		}
	});

	return Slider;
})();



$(document).ready(function() {
	window.sections = new slate.Sections();
	window.sections.register('slider', theme.Slider);
	
	// Apply a specific class to the html element for browser support of cookies.
	if (slate.cart.cookiesEnabled()) {
		document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
	}
	
	/** * INIT THEME * **/
	theme.init();
});


//====================================== //
//================ THEME =============== //
//====================================== //

/*
	Caching dom elements
*/
theme.selectors = function() {
	theme.cache = {
		$window					: $(window),
		$body					: $('body,html'),
		$header					: $('header#header'),
		$menu					: $('#header .menu'),
		//$mobileMenu				: $('#mobileMenu'),
		$heroHome				: null,
		$toScroll				: $('[data-to-scroll]'),
		//$searchWrapper			: $('#search-wrapper'),
		$searchTrigger			: $('[data-search-trigger]'),
		$search					: $('#search'),
		//$searchResults			: $('#search-results'),
		$slickCollectionTabs	: $('[data-collectionPanes] .slickCollectionTabs'),
		$slickCollectionSlider	: $('.slickCollectionSlider'),
		$slick5Up				: $('.slider-5-up'),
		$sizeChart				: $('[data-topic="size-chart"]'),
		$templatePromoID		: $('#templatePromo'),
		$collectionTab			: null,
		//$contactForm			: null,
		searchOpen				: false,
		viewportWidth			: document.documentElement.clientWidth,
		sm						: 576,
		md						: 768,
		lg						: 992,
		xl						: 1200
	};
}

/**
	* Init key functions
**/
theme.init = function() {
	theme.utils.handlebarsHelper();
	theme.selectors();
	theme.computeVH();
	theme.stickyNav();
	theme.scrollingHeader();
	theme.desktopMenu();
	// theme.mobileMenu();
	theme.newsletter();
	theme.collectionClick();
	theme.utils.templatePromoText();


	// Window resize
	theme.windowResize();

	//Search
	theme.showSearchBlock();
	// theme.liveSearch();

	//if ($('[data-feature="quickShopHTML"]')) theme.utils.quickShopInit();
	
	// HOMEPAGE
	if (bodyClasses.contains('template-index')) {
		theme.cache.$heroHome = $('.template-index .hero');
		theme.cache.$collectionTabs = $('[data-collectionTabs]');
		theme.cache.$sizeChart = $('[data-topic="size-chart"]');
		theme.collectionTabs();
		theme.slickCollectionTabs();
	}

	// LOOKBOOK PAGE
	if (bodyClasses.contains('template-look-book') || bodyClasses.contains('template-look-book2') || bodyClasses.contains('template-look-book3') || bodyClasses.contains('template-look-book4') || bodyClasses.contains('template-look-book5')) {
		var validatePassword = function() {
			const password = $('#lookbookPassword').val();
			const hash = CryptoJS.HmacSHA256(password, "VIPAccessRocks").toString();
			
			if (hash == window.theme.lookbookHash) {
				$('#modalPassword').modal('hide');
				$('.err-msg').addClass('d-none');
			} else {
				$('.err-msg').removeClass('d-none');
			}
		}

		$('#modalPassword').modal();
	
		$('#passwordSubmit').on('click', function() {
			validatePassword();
		});

		$('#lookbookPassword').keypress(function (e) {
			var key = e.which;
			if (key == 13) validatePassword();	
		});   

		theme.slickCollectionSlider();
	}

	// SPECIAL COLLECTION
	if (bodyClasses.contains('template-men') || bodyClasses.contains('template-women') || bodyClasses.contains('template-kids') || bodyClasses.contains('template-slider-test')) {
		theme.cache.$sizeChart = $('[data-topic="size-chart"]');
		// Init Collection Tabs 
		theme.cache.$collectionTabs = $('[data-collectionTabs]');
		theme.collectionTabs();
		theme.slickCollectionTabs();
	}

	// COLLECTION 
	if (bodyClasses.contains('template-collection')) {
		theme.slickCollectionSlider();
		theme.cache.$sizeChart = $('[data-topic="size-chart"]');
	}
	
	// PDP
	if (bodyClasses.contains('template-product')) {
		theme.cache.$sizeChart = $('[data-topic="size-chart"]');

		// Enable popovers
		$(function () {
			$('[data-toggle="popover"]').popover()
		});

		// Hide any open popovers when the anywhere else in the body is clicked
		$('body').on('click', function (e) {
			$('[data-toggle=popover]').each(function () {
				if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
					$(this).popover('hide');
				}
			});
		});
	}

	// CONTACT PAGE
	//if (bodyClasses.contains('template-contact')) {
	//	theme.cache.$contactForm = $('#contact_form');
		//theme.contactSelect();
	//}
	
	// COLLECTIONS 5 UP
	if ( theme.cache.$slick5Up.length )
		theme.Slider5Up();
	
	// FORMS validation
	var $forms = $('form[data-validate="true"]')
	if ($forms.length) { theme.formsValidation($forms); }
	
	// GUARANTEES
	theme.displayModalGuarantee();

	// Quickshop
	theme.utils.quickShopInit();
}


theme.windowResize = function() {
	theme.cache.$window.on('resize', function() {
		theme.cache.viewportWidth = document.documentElement.clientWidth;
	});
}

/*******************************************
*			  	STICKY NAV				   *
*******************************************/
theme.stickyNav = function() {
	var headerHeight = theme.cache.$header.height(),
	  topBarHeight = $('#shopify-section-top-bar:visible').eq(0).height() || 0,
	  fastMenuHeight = $('#shopify-section-fast-menu:visible').eq(0).height() || 0,
	  sectionsHeight = topBarHeight + fastMenuHeight,
	  navHeight = theme.cache.$menu.height(),
	  limit = (topBarHeight) ? topBarHeight : (headerHeight-navHeight - 3), // Will change if top bar is active or not
	  // checking menu transparency setting in theme settings as well as snippets
	  transparentGlobalHeader = window.transparent_global_header && window.header_transparent;
	  transparentEligible = !!(theme.cache.$header.data('transparent') == 1 || transparentGlobalHeader );
	  
	// Update the Root element (mostly for mobile)
	document.documentElement.style.setProperty('--top-bar-height', topBarHeight+'px');
	
	// IF THE PAGE HAS A HERO OR DECLARE THE NEED FOR A TRANSPARENT HEADER
	// WE ADD the CLASS .trnasparent to header
	if (transparentEligible) theme.cache.$header.addClass('transparent');

	function sticky() { 
		var scrollTop = theme.cache.$window.scrollTop();
		
		// if the Fast menu is there we compensate (mobile)
		if (fastMenuHeight)
			document.documentElement.style.setProperty('--menu-stick-top', sectionsHeight-scrollTop+'px');
		
		// Top Bar (from start)
		if (scrollTop > 0.2) {
			theme.cache.$header.addClass('header-top-active header-active-transition');
		} else {
			theme.cache.$header.removeClass('header-top-active header-active-transition');
		}
		// Remove transition class
		if (scrollTop > limit) {
			theme.cache.$header.removeClass('header-active-transition');
		}
		
		// Menu
		if (scrollTop > limit ) {
			theme.cache.$header.addClass('header-active');
			theme.cache.$header.removeClass('transparent');
		} else {
			theme.cache.$header.removeClass('header-active');
			if ( transparentEligible ) 
				theme.cache.$header.addClass('transparent');
		}
	}
	
	// Unbind / bind (For window resize event purpose)
	theme.cache.$window.unbind('scroll', sticky);
	theme.cache.$window.bind('scroll', sticky);
	
	// SIMULATE HOVER (less CSS clutter) + // Init on load
	if (!transparentEligible)
		return sticky();
	
	// Return if smaller than iPad (Portrait)
	if (document.documentElement.clientWidth < theme.cache.md) return false;
	
	theme.cache.$header.on('mouseenter', function(e) {
		if ( !theme.cache.$header.hasClass('header-active') )
			theme.cache.$header.removeClass('transparent');
	}).on('mouseleave', function(e) {
		if ( !theme.cache.$header.hasClass('header-active') && !theme.cache.$header.hasClass('search-active')  && !theme.cache.$header.hasClass('menu-active')  )
			theme.cache.$header.toggleClass('transparent');
	});
}

/**
 * Scrolling header feature
 */
theme.scrollingHeader = function() {
	// Get current scroll position
	let scrollPosition = theme.cache.$window.scrollTop(),
	// How many PX from the top until the scrolling header feature is enabled - 175px on all pages EXCEPT New Collections
	  entryDistance = !theme.currentTemplate && theme.currentPage === 'collection' ? getFilterPosition() : 175;
	  scrollState = 'default', //states = default, scrollDown, scrollUp
	  stickyElements = []; // array with the elements: top bar, timer, nav, filter
	const navBarHeight = parseInt(getComputedStyle(document.body).getPropertyValue('--navbar-height')) || 0;

	/**
	 * Get the distance (in pixels) of the filters from the top of the page
	 * @returns {Number}
	 */
	function getFilterPosition() {
		return getDistanceFromTop(document.querySelector('[data-collection-filters]'));
	}

	/**
	 * Grab all necessary elements and save them in elements to improve performance
	 */
	const buildStickyElements = () => {
		// add to array: top bar, timer, nav, filter
		const elements = document.querySelectorAll('[data-sticky-element]');
		elements.forEach((element) => stickyElements.push(element));
	}

	// Set scroll event listener
	document.addEventListener('scroll', (e) => {
		// get new scroll position
		const newScrollPosition = theme.cache.$window.scrollTop();
		// call updateScrollState(scrolldown(newPosition))
		updateScrollState(scrollDown(newScrollPosition));
	});
			
	/**
	 * Calculates if the user is scrolling down or up
	 * @param {Number} newPosition
	 * @returns {Boolean}
	 */
	function scrollDown(newPosition) {
		// Save previous position in local variable and update scroll position in outer scope (only if change in scroll position is > 200px)
		const oldPosition = scrollPosition;
		// Some features like drawer cart scroll the page to the top, if we detect that the scroll position is 0 we do not change state
		if (Math.abs(scrollPosition - newPosition) > 200 && newPosition !== 0) scrollPosition = newPosition;
		// if newPosition > scrollPosition return true
		if (newPosition > oldPosition) return true;
		else return false;
	}

	/**
	 * Checks if scroll state update is necessary
	 * @param {Boolean} scrollDown 
	 */
	function updateScrollState(scrollDown) {
		// IF scrolled past filters
		if (scrollPosition > (entryDistance - navBarHeight)) {
			// IF scrollDown && scrollState !== 'scrollDown'
			if (scrollDown && scrollState !== 'scrollDown') {
				//scrollState = 'scrollDown'
				scrollState = 'scrollDown';
				updateUI()
			}
			// Scroll MUST be UP - IF scrollState !== 'scrollUp'
			if (!scrollDown && scrollState !== 'scrollUp') {
				//scrollState = 'scrollUp'
				scrollState = 'scrollUp';
				updateUI();
			}			
		} else {
			// IF scrollstate !== 'default'
			if (scrollState !== 'default') {
				//scrollState = 'default'
				scrollState = 'default';
				updateUI();
			}
		}	
	}

	/**
	 * Update the class names on the UI elements to reflect the current scroll state
	 */
	function updateUI() {
		// Grab sticky elements just once
		if (stickyElements.length === 0) buildStickyElements();
		//IF scrollState === 'default'
		if (scrollState === 'default') {
			// for each element remove 'scrollUp', 'scrollDown'
			stickyElements.forEach((element) => element.classList.remove('scrollUp', 'scrollDown'));
		}
		//IF scrollState === 'scrollDown'
		if (scrollState === 'scrollDown') {
			// for each element add 'scrollDown' class - remove 'scrollUp'
			stickyElements.forEach((element) => {
				element.classList.remove('scrollUp');
				element.classList.add('scrollDown');
			}); 
		}
		//IF scrollState === 'scrollUp'
		if (scrollState === 'scrollUp') {
			// for each element add 'scrollUp' class - remove 'scrollDown'
			stickyElements.forEach((element) => {
				element.classList.remove('scrollDown');
				element.classList.add('scrollUp');
			}); 
		}
	}

	/**
	 * Get distance between the element and top of the document
	 * @param {Object} element 
	 * @returns {Number}
	 */
	function getDistanceFromTop(element) {
		let distance = 0;

		while(element) {
			distance += (element.offsetTop);
			element = element.offsetParent;
		}
		return distance;
	}
}

/*******************************************
  MOBILE MENU
*******************************************/
/**
 * Compute distance from top to menu to end of screen
 * Assign it to :root css
**/
theme.distanceToBottom = function() {
	var top = theme.cache.$menu.position().top,
	  innerHeight = window.innerHeight,
	  h = innerHeight - top;
	
	document.documentElement.style.setProperty('--vh-menu-to-bottom', h+'px');
}

/**
 * Compute VH
 * Assign to root var in css
**/
theme.computeVH = function() {
	var vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', vh+'px');
}

/**
 * Add / remove classes on mobile menu openening / closing
**/
/*
theme.mobileMenu = function() {
	if (theme.cache.viewportWidth > theme.cache.lg) return false;
	var $searchIcon = $('[data-search-trigger]', theme.cache.$header);

	theme.cache.$mobileMenu.on('show.bs.collapse', function (e) {
		theme.distanceToBottom();
		theme.cache.$header.addClass('menu-active');
		bodyClasses.add('stop-scroll');
		$searchIcon.addClass('off');
	}).on('hide.bs.collapse', function (e) {
		theme.cache.$header.removeClass('menu-active');
	}).on('hidden.bs.collapse', function (e) {
		bodyClasses.remove('stop-scroll');
		$searchIcon.removeClass('off');
	});
}
*/

/**
 * Add / remove classes on Desktop menu Hover
**/
theme.desktopMenu = function() {
	if (theme.cache.viewportWidth < theme.cache.lg) return false;
	
	var $menuItems = theme.cache.$menu.find('.main-menu .nav-item'),
	  $menuItemsDropdown = $menuItems.filter('.dropdown')
	  $dropdownMenus = $menuItemsDropdown.find('.dropdown-menu');
	
	// ON Clicks
	$menuItemsDropdown.on('click', 'a', function(e) {
		window.location.href = $(e.target).attr('href');
	});
	
	// Hover on
	$menuItemsDropdown.on('mouseenter', function(e) {
		// When Search is active drop down menu will not open
		if ( theme.cache.$header.hasClass('search-active') ) return;
		var $this = $(this), id = $this.find('a').attr('id');
		
		$this.addClass('show').attr('aria-expanded', true);
		$this.find('.dropdown-menu').addClass('show');
		theme.cache.$header.addClass('menu-active');
		
		// Clear previously opened submenu
		$menuItemsDropdown.not('[id="'+id+'"]').removeClass('show').attr('aria-expanded', false);
		$dropdownMenus.not('[aria-labelledby="'+id+'"]').removeClass('show');
	});

	// Menu items without a dropdown
	$menuItems.not('.dropdown').on('mouseenter', function(e) {
		$menuItemsDropdown.removeClass('show').attr('aria-expanded', false);
		$dropdownMenus.removeClass('show');
		theme.cache.$header.removeClass('menu-active');
	});
	
	// Hover off
	$dropdownMenus.on('mouseleave', function(e) {
		var $this = $(this);
		$this.removeClass('show');
		$this.parents('.nav-item.dropdown.show').removeClass('show').attr('aria-expanded', false);
		theme.cache.$header.removeClass('menu-active');
	});
}

// ALL PAGES JS CLICK
theme.collectionClick = function() {	
	$('[data-url-link]').on('click', function(e) {
		e.preventDefault();
		var url = $(this).data('url-link');
		if (url) window.location.href = url;
	});
}

/*******************************************
  HOMEPAGE
*******************************************/

/**
 * Background Video - Youtube
 * Launch auto play
**/
theme.backgroundVideo = function() {
	var youtube_id, host;
	// Check if dome Element is there
	if (!theme.cache.$heroHomeVideo.length) return;
	youtube_id = theme.cache.$heroHomeVideo.data('youtube-id');
	host = theme.cache.$heroHomeVideo.data('request-host');
	
	// Check you tube ID
	if (!youtube_id) return;
	
	// YOUTUBE JS
	window.onYouTubeIframeAPIReady = function() {
		var player;
		player = new YT.Player('heroVideoPlayer', {
			videoId: youtube_id,	// YouTube Video ID
			playerVars: {
				height: "100%",
				width: "100%",
				autoplay: 1,		// Auto-play the video on load
				disablekb: 1, 
				controls: 0,		// Hide pause/play buttons in player
				showinfo: 0,		// Hide the video title
				modestbranding: 1,	// Hide the Youtube Logo
				html5: 1,
				playsinline: 1,
				loop: 1,			// Run the video in a loop
				fs: 0,				// Hide the full screen button
				autohide: 0,		// Hide video controls when playing
				rel: 0,
				enablejsapi: 1,
				iv_load_policy: 3,
				origin: host
			},
			events: {
				onReady: function(e) {
					e.target.mute();
					e.target.setPlaybackQuality('hd1080');
					e.target.playVideo();
				},
				onStateChange: function(e) {
					if (e && e.data > 0) {
						theme.cache.$heroHomeVideo.addClass('loading-off');
					} else if (e && e.data === 0) {
						e.target.playVideo();
					}
				}
			}
		});
	}
}


/**
 * LIVE SEARCH for instant search
**/
theme.showSearchBlock = function() {	
	// checking menu transparency setting in theme settings as well as snippets
	var transparentGlobalHeader = window.transparent_global_header && window.header_transparent,
	  transparentEligible = !!(theme.cache.$header.data('transparent') == 1  || transparentGlobalHeader ),
	  $dropdownMenus = theme.cache.$header.find('.main-menu .nav-item.dropdown .dropdown-menu');
	var is_homepage = bodyClasses.contains('template-index');
	  
	// TRIGGER
	theme.cache.$searchTrigger.on('click', function(e) {
		e.preventDefault();
		
		// Close the menu if already open
		$dropdownMenus.filter('.show').removeClass('show').attr('aria-expanded', false);
		theme.cache.$search.val('');
		theme.cache.searchOpen = true;
		theme.cache.$header.toggleClass('search search-active');

		if (is_homepage) {
			if ( !BNS.isOn() ) {
				BNS.on('fixed-scolling');
			} else {
				BNS.off('fixed-scolling');
			}
		}
		
		setTimeout(function() {
			theme.cache.$search.focus();
		}, 600);
		
	});
	
	// CLOSE SEARCH
	$('#close-search').on('click', function(e) {
		e.preventDefault();
		theme.cache.$search.blur();
		theme.cache.$search.val('');
		// theme.cache.$searchResults.removeClass('on');
		theme.cache.$header.removeClass('search search-active');
		if (is_homepage) {
			BNS.off('fixed-scolling');
		}
		theme.cache.searchOpen = false;
		if (transparentEligible && !theme.cache.$header.hasClass('header-active'))
			theme.cache.$header.addClass('transparent');
	});


    // ClEAR SEARCH BAR ON SUBMIT
	$('.search-form').on('keypress',function(e) {
		if(e.which == 13) {
			setTimeout(function() {
				theme.cache.$search.val('');
			}, 600);
		}
	});
}

/* *****************************************
	PRODUCT GRIDS
***************************************** */
/*
 * Set identical height on Product grids - Product info
 *
 * @param {DOM} $container
*/
theme.productGrids = function($container) {
	var minHeight = 0, 
	  $targets = $('.product-grid  .product-info', $container),
	  $arrows = $('.slick-arrow', $container);

	  // Clean previous Height
	  $targets.removeAttr('style');
	
	$('.product-grid .product-info', $container).each(function() {
		var h = $(this).height();
		if (minHeight < h)
			minHeight = h;
    });
    
    // Set min Height
    if ( minHeight > 0 ) {
	    $targets.css('min-height', minHeight);
	    // Compensate arrow vetical position 
	    $arrows.css('margin-top', (minHeight)*-1);
    }
}

/* *****************************************
	COLLECTION TABS
***************************************** */
theme.collectionTabs = function() {
	// Loop through all the collections tab on the page
	theme.cache.$collectionTabs.each(function() {
		var $this = $(this), 
		  sectionID = $this.attr('data-section-id'),
		  $goToCollection = $('#goToCollection-'+sectionID);
		  
		// ON click (before change) -> Update button link \\
		$this.find('[data-toggle="tab"]').on('show.bs.tab', function(e) {
			var url = $(e.currentTarget).data('collection-url');
			$goToCollection.attr('href', url).removeClass('on');
		});
		
		// After Tab transition is completed (re)set slider position \\
		$this.find('[data-toggle="tab"]').on('shown.bs.tab', function(e) {
			var id = $(e.target).attr('href');
			// Re Set slider position
			$(id+' > .slick-slider').slick('setPosition');
			$goToCollection.addClass('on');
		});
	});
}

/* *****************************************
	COLLECTION TABS SLIDER
***************************************** */
theme.slickCollectionTabs = function() {
	// Loop thru each slider in the Tabs
	theme.cache.$slickCollectionTabs.each(function() {
		var $this = $(this);

		$this.on('init', function() {
			theme.productGrids($this);
		});
		
		$this.on('setPosition', function() {
			theme.productGrids($this);
		});
		
		$this.slick({
			infinite: false,
			slidesToShow: 2.2,
			slidesToScroll: 2,
			dots: true,
			arrows: false,
			mobileFirst: true,
    		rows: 2,
			responsive: [
				{
				  breakpoint: theme.cache.lg,
				  settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
					dots: true,
					arrows: true,
    				rows: 1
				  }
				}
			  ]
		});
	});
}

/* *****************************************
	COLLECTION SLIDER
***************************************** */
theme.slickCollectionSlider = function() {
	theme.cache.$slickCollectionSlider.on('init', function() {
		theme.productGrids(theme.cache.$slickCollectionSlider);
	});
		
	theme.cache.$slickCollectionSlider.on('setPosition', function() {
		theme.productGrids(theme.cache.$slickCollectionSlider);
	});
		
	theme.cache.$slickCollectionSlider.slick({
		infinite: false,
		slidesToShow: 2.2,
		slidesToScroll: 2,
		dots: true,
		arrows: false,
		mobileFirst: true,
		rows: 2,
		responsive: [
			{
			  breakpoint: theme.cache.lg,
			  settings: {
				slidesToShow: 4,
				slidesToScroll: 4,
				dots: true,
				arrows: true,
				rows: 1
			  }
			}
		  ]
	});
	
}

/* *****************************************
	COLLECTION % UP SLIDER
***************************************** */
theme.Slider5Up = function() {
	theme.cache.$slick5Up.each(function() {
		// Stop if PDP and Desktop
		if (bodyClasses.contains('template-product') 
			&& theme.cache.viewportWidth >= theme.cache.lg ) 
				return false;

		var $this = $(this); 
		// Call function after slider is created
		$this.on('init', function() {
			theme.collectionClick();
		});

		$this.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: false,
			mobileFirst: true,
			responsive: [
				{
				  breakpoint: theme.cache.lg,
				  settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					dots: false,
					arrows: true
				  }
				}
			  ]
		});
	});
}

/*******************************************
  SIZE CHART
*******************************************/
theme.sizeChart = function() {
	var $page = $('#sizeChartContent, #injectContent'),
	  $genderSelects = $('.gender-select', $page),
	  $navs = $('.nav-wrap', $page);
	  	
	// Toggle Classes
	$genderSelects.on('click', function(e) {
		e.preventDefault();
		// Failsafe for if element clicked isn't active or doesn't have href
		if ($(e.currentTarget).hasClass('gender-active')) return;
		if (!$(e.currentTarget).attr('href')) return;

		// Element that was clicked is marked as active
		$genderSelects.removeClass('gender-active');
		$(e.currentTarget).addClass('gender-active');

		// Corresponding chart is shown
		var $selectedNav = $($(e.currentTarget).attr('href'), $page)
		$navs.addClass('d-none');
		$selectedNav.removeClass('d-none');
	});
}

/**
 * Display Size Chart Modal
**/
theme.displayModalGuarantee = function() {
	$('#modalGuarantees').on('show.bs.modal', function(e) {
		var $target = $(e.relatedTarget), 
		  $modal = $(e.target);
		
		$modal.find('#guaranteeIcon img').attr( 'src', $target.data('src') );
		$modal.find('#guaranteeTitle').text( $target.data('heading') );
		$modal.find('#guaranteeCopy').html( $target.data('copy') );			
	});
}

/* *****************************************
	FORMS VALIDATION
***************************************** */
/**
 * Form validation - using parsley
**/
theme.formsValidation = function($forms) { $forms.parsley(); }


/* *****************************************
	NEWSLETTER KLAVIYO
***************************************** */
theme.newsletter = function() {
	var form = $('form#newsletter-footer'),
	  btn = $('#subscription_submit');
	
	function klavioGO(data) {
		$.ajax({  
			type: "POST",  
			url: "/contact",
			async: true,
			data: data})
			.done(function(r) {
				btn.text('Thank you').prop("disabled", true);
			})
			.fail(function(){
				btn.text('Sorry, Try Again').prop("disabled", true);
			});
	}
	
	// Send
	form.submit(function(e) {
		e.preventDefault();
		var email = $('#k_id_email').val(),
		  reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		
		if (reg.test(String(email).toLowerCase())) {
			console.log(this);
			var data = $(this).serialize();
			btn.text('Sending...').prop("disabled", true);
			klavioGO(data);
		} else {
			form.text('invalid email');
			setTimeout(function() {
				btn.text('SUBSCRIBE');	
			}, 3000);
		}
	});
}

/**
 * AJAX calls
**/
theme.ajax = function(options, data, callback, callbackFail, callback404) {
	var com;
	// Set up defaults
	if (!options) return false;
	// Setup Ajax
	$.ajaxSetup(options);
	
	if (options.dataType == 'jsonp')
		com = $.ajax({ data: data });
	else if (options.data)
		com = $.ajax();	
	else
		com = $.ajax({ 
			data: data,
			statusCode: { 
				404: function() {
					if (callbackFail)
						return callbackFail('404')
				}
			}
		});
	
	com.done(function(res) {
		if (callback)
			return callback(res);
	})
	.fail(function(jqXHR, textStatus, errorThrown) {
		if (callbackFail)
			return callbackFail;
	});
}

/**
 * Fix iOS bug in CSS vh
**/
theme.iosBadVH = function() {
	// fix iOS bug in CSS vh
	// https://gist.github.com/pburtchaell/e702f441ba9b3f76f587
	var isBadIos = function() {
		var regex = /(iPhone|iPad|iPod);[^OS]*OS (\d)/;
		var matches = navigator.userAgent.match(regex);
		if (!matches) return false;
			return matches[2] < 8;
	}
	
	if (isBadIos()) {
		var h = document.documentElement.clientHeight || 0;
		if (h && !theme.cache.$heroHome.hasClass('hero-for-video')) theme.cache.$heroHome.height(h+1);
	}
}

/**
	* Listen to click on element
	* displaying data-to-scroll.
	* data-scroll-speed is optional
**/
theme.toScroll = function() {
	theme.cache.$toScroll.on('click', function(e) {
		var h = e.currentTarget.hash || null,
		  s = $(this).attr('data-scroll-speed') || null;
		if (h) {
			e.preventDefault();
			theme.scroller(h, s);
		}
	});
}

/**
	* Scroll viewport to position
	* @param {String} hash
	* @param {Number} duration
	* @param {Function} cb
**/
theme.scroller = function(hash, duration, cb) {
	var target = $(hash),
	  dur = duration || 800;

	if (target.length) {
		theme.cache.$body.animate({
			scrollTop: target.offset().top
		}, dur, 'easeInCubic')
		.promise().done(cb);
	}
	return;
}
 
/* ======================================================================= */
/* ========== 					THEME UTILS						========== */
/* ======================================================================= */
theme.utils = {
	/**
	 * dataModifier for Shopify AJAX data
	 * Modified data - Ready for templating
	 *
	 * @param {Array} data
	 * @return {Array}
	 *
	**/
	dataModifier: function(data) {
		for (var d in data) {
			data[d]['price'] = data[d]['price']/100;
			data[d]['compare_at_price'] = data[d]['compare_at_price']/100;
			data[d]['on_sale'] = (data[d]['compare_at_price'] !== data[d]['price']);
			data[d]['img'] = theme.utils.resizeImage(data[d]['media'][0]['src'] || window.theme.noImage.url, '768x');
			data[d]['imgsrcSet'] = this.createImageSrcSet(data[d]['media'][0]['src'] || window.theme.noImage.url);
			data[d]['available_sizes'] = [];
			if (data[d]['on_sale'] === true && window.showSavingsPercent === true) 
				data[d]['sale_percent'] = theme.utils.calculateDiscount(data[d]['price'], data[d]['compare_at_price']);
				
			if (data[d].collections) data[d]['promo_text'] = theme.utils.promoText(data[d].collections || null, data[d].tags || null)
			
			// Get Size position in array (if any)
			// Loop through variants and build available_sizes object array for quick-shop feature
			data[d].variants.forEach((variant) => {
				data[d]['available_sizes'].push({id: variant.id, size: variant.option1});
			});
			
			// IF we have more than 1 image to show
			if (data[d]['media'].length > 1) {
				data[d]['img_2'] = theme.utils.resizeImage(data[d]['media'][1]['src'], '768x');
				data[d]['imgsrcSet_2'] = this.createImageSrcSet(data[d]['media'][1]['src']);
			}
		}
		return data;
	},

	/**
	 * Check product for promo code matches and return promo text and color
	 * @param {Number|Object[]} collectionId 
	 * @param {String} productTags 
	 */
	promoText: function(collectionId, productTags){
		let result = {},
		collectionIdArr;

		// This feature is only for collections pages & pdp
		if(!(theme.currentPage === 'collection' || theme.currentPage === 'product' || theme.currentPage === 'index')) return;

		// Check if product belongs to more than 1 collection
		if (Array.isArray(collectionId)) {
			// Clean up ISP's mess of nested arrays
			if (Array.isArray(collectionId[0])){
				collectionIdArr = [];
				collectionId.forEach((collection) => {
					collectionIdArr.push(parseInt(collection[0]));
				});
			} else {
				// Handle collection array from Shopify
				collectionIdArr = collectionId.map((arrayObj) => arrayObj.id);
			}
		} else {
			collectionId = parseInt(collectionId);	
		}

		// Loop each promo, checking for promo matches
		for (let i = 0; i < window.activePromos.length; i++) {

			// Assign others
			const targetCollection = window.activePromos[i].targetCollection,
			  promoText = window.activePromos[i].promoText,
			  promoColor = window.activePromos[i].promoColor;
			let targetTags = window.activePromos[i].targetTags;

			// split targetTags string into array
			targetTags = (Array.isArray(targetTags) ? targetTags : targetTags.split(','));

			// Set targetTags to falsy if there are none present - empty arrays evaluate to truthy so we need to evaluate them differently
			if (Array.isArray(targetTags) && targetTags.length === 1 && targetTags[0] === '') targetTags = false;

			// Handleize tags
			if (targetTags) targetTags = targetTags.map((tag) => this.handleize(tag)); // From promo backend
			if (productTags) productTags = productTags.map((tag) => this.handleize(tag));			   // From product tags

			//Scenario 1 - Collection & tags
			if (targetCollection && targetTags) {
				// Check if we have multiple collections on the product
				if (collectionIdArr) {
					// Loop each collection that the product belongs to
					const collectionArrIndex = collectionIdArr.indexOf(targetCollection);
					// If collectionID not found in array, break
					if (collectionArrIndex !== -1) {
						// COLLECTION MATCHES
						result =  { promoText: promoText, promoColor: promoColor };
						continue;
					}
				} else if (collectionId) {
					if (collectionId === targetCollection) {
						result =  { promoText: promoText, promoColor: promoColor };
						continue;
					}
				}
				// Search every promo tag to see if it matches at least one product tag
				for (let t in targetTags) {
					if (productTags && productTags.indexOf(targetTags[t]) !== -1){
						// PRODUCT TAG MATCHES
						result =  { promoText: promoText, promoColor: promoColor };
						break;
					}
				}
			}

			//Scenario 2 - Collection & no tags
			else if (targetCollection && !targetTags) { 
				// Check if we have multiple collections on the product
				if (collectionIdArr) {
					// Loop each collection that the product belongs to
					const collectionArrIndex = collectionIdArr.indexOf(targetCollection);
					// If collectionID not found in array, break
					if (collectionArrIndex === -1) break;
					// Reassign collectionID to correct index
					collectionId = collectionIdArr[collectionArrIndex];
				} 
				if (collectionId === targetCollection) {
					result =  { promoText: promoText, promoColor: promoColor }; 
					continue;
				}
			}
			
			//Scenario 3 - No collection & tags present
			else if (!targetCollection && targetTags) {
				for (let t in targetTags) {
					if (productTags && productTags.indexOf(targetTags[t]) !== -1){
						// PRODUCT TAG MATCHES
						result =  { promoText: promoText, promoColor: promoColor };
						break;
					}
				}
			}
		}
		return result;
	},

	/**
	 * Template product promo text within liquid sections
	 */
	templatePromoText: function() {
		// Get all promo text elements
		const promoElements = document.querySelectorAll('[data-promo-liquid]');

		// Iterate each element
		for (let i = 0; i < promoElements.length; i++) {
			// If the promo is already templated, skip it
			if (promoElements[i].innerHTML !== '') continue;

			const collections = promoElements[i].getAttribute('data-product-collections').split(',');
			const tags = promoElements[i].getAttribute('data-product-tags').split(',');

			// Compile
			const source 		= theme.cache.$templatePromoID.html();
			template 		= Handlebars.compile(source),
			html 			= template(theme.utils.promoText(collections, tags));

			// Inject HMTL
			promoElements[i].innerHTML = html;
		}
	},
	
	/**
	 * Calculates the percentage difference between the price and compare at price
	 *
	 * @param {Number} price
	 * @param {Number} compare_at_price
	 * @returns {Integer} Sales discount percentage
	 *
	 */
	 calculateDiscount: function(price, compare_at_price) {
		price = parseInt(price);
		compare_at = parseInt(compare_at_price);
		
		const discountPercent = Math.abs(((price - compare_at) / compare_at) * 100);
		
		return Math.round(discountPercent); 
	},
	
	/**
	 * Resize Shopify Image
	 * modify url
	 * @param {string} src
	 * @param {Number} size
	 * @return {String}
	 *
	**/
	resizeImage: function (src, size) {
		if (size == null) return src;
		let match, prefix, suffix;

		// Clean Large instruction in URL
		src = src.replace('_large.', '.');

		match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

		if (match != null) {
			prefix = src.split(match[0]);
			suffix = match[0];
			return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
		} else {
			return null;
		}
	},
	
	/**
	 * Create image Source Sets (Lazyloading)
	 * @param {string} src
	 * @return {String}
	**/
	createImageSrcSet: function(src) {
		if (!src) return src;
		
		const sizes = [180,360,540,720,900,1080,1296];
		let srcSet = [];
		
		// Add sizes
		sizes.forEach((size) => {
			const x = size+'x', w = ' '+size+'w';
			srcSet.push( this.resizeImage(src, x)+ w );
		});
		
		return srcSet.join(',');
	},

	/**
	 * Quickshop Feature
	**/
	quickShopInit: function () {
		const quickShop = $('[data-feature="quickShop"],[data-feature="quickShopHTML"]').filter(':not(.quick-shop-inited)');
		quickShop.addClass('quick-shop-inited');

		/**
		* Handles a user hovering over the addToBag button on Desktop
		* @param {Object} e
		*/
		const quickShopHandler = (e) => {
			// Handle Click (MOBILE)
			if (e.type === 'touchstart') {
				//e.preventDefault();
				const parent = $(e.target).parents('.img-wrap:not(.out-of-stock)');
				parent.toggleClass('active');
				// Handle mouse hover (DESKTOP)
			} else {
				// Check if mobile
				let touchStatus	= getComputedStyle(touchDetect).display !== 'inline-block'; // true == mobile
				if (touchStatus) return;
				const parent = $(e.target).parents('.img-wrap:not(.out-of-stock)');
				parent.addClass('active');
			}
		}

		/**
		* Adds the clicked size to the cart
		*/
		const addSizeToCart = function (e) {
			e.preventDefault();
			const variantID = e.target.getAttribute('data-variant-id'),
			msgBox = $(e.target).parents('.inner').children('.msg-wrap'),
			parent = $(e.target).parents('.img-wrap');

			window.DrawerCartApi.addToCart(variantID);
			parent.addClass('clicked');
			msgBox.addClass('added');
			setTimeout(function () {
				parent.removeClass('clicked');
				parent.removeClass('active');
				msgBox.removeClass('added');
			}, 2000);
		}

		/**
		* Handle mouse leaving hover
		*/
		const quickShopOff = function (e) {
			const parent = $(e.target).parents('.img-wrap');
			parent.removeClass('active');
		}

		// Event Handlers
		quickShop.off('mouseenter', '.add-to-bag-btn', quickShopHandler);
		quickShop.on('mouseenter', '.add-to-bag-btn', quickShopHandler);

		// Event Handler on add-to-bag-wrap for mobile to make it easier to tap
		quickShop.off('touchstart', '.add-to-bag-wrap', quickShopHandler);
		quickShop.on('touchstart', '.add-to-bag-wrap', quickShopHandler);

		quickShop.off('mouseleave', '.select-size-wrap', quickShopOff);
		quickShop.on('mouseleave', '.select-size-wrap', quickShopOff);

		quickShop.off('click', '.quick-shop-size', addSizeToCart);
		quickShop.on('click', '.quick-shop-size', addSizeToCart);
	},
	
	/**
	 * Add cycle function to Handlbar
	**/
	handlebarsHelper: function() {
		Handlebars.registerHelper('cycle', (value, block) => {
			const values = value.split(' ');
			return values[block.data.index % (values.length)];
		});
	},
	
	/**
	 * Handleize string like Shopify
	 * handleize function
	 * @param {String} string
	 * @return {String}
	**/
	handleize: function(string) {
		return (typeof string == 'string') ? string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') : string;
	}	
}

// Helper
jQuery.extend(jQuery.easing, {
	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
	}
});

// Avoid the use passive listeners to improve scrolling performance in jQuery
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ){
        this.addEventListener("touchstart", handle, { passive: true });
    }
}